import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';

import {SiteConfigRule} from '../../../../../models/site-config-rule';
import {SiteConfigRuleService} from '../../../../../services/site-config-rule/site-config-rule.service';
import {LoaderService} from '../../../../../services/loader/loader.service';
import {DialogService} from '../../../../../services/dialog/dialog.service';
import {forkJoin} from 'rxjs';
import {AuthService} from '../../../../../services/auth/auth.service';
import {SiteConfigParamService} from '../../../../../services/site-config-param/site-config-param.service';
import {SiteConfigParam} from '../../../../../models/site-config-param';
import {FormsModule} from '@angular/forms';
import {
  SiteConfigElementComponent
} from '../../../../layout/site-config/site-config-element/site-config-element.component';
import {IsGranted} from '../../../../../decorator/is-granted';
import {MetaTitle} from '../../../../../decorator/meta-title';

@Component({
  selector: 'app-site-config',
  imports: [
    FormsModule,
    SiteConfigElementComponent
],
  templateUrl: './site-config-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './site-config-list.component.scss'
})
@IsGranted(['SITE_VIEW'])
@MetaTitle('Behavior config')
export class SiteConfigListComponent implements OnInit {
  siteConfigRules: SiteConfigRule[] = [];
  siteConfigParams: SiteConfigParam[] = [];

  constructor(
    private loader: LoaderService,
    private dialog: DialogService,
    private auth: AuthService,
    private siteConfigRuleService: SiteConfigRuleService,
    private siteConfigParamService: SiteConfigParamService,
  ) {
  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh(): void {
    this.loader.startLoading();

    forkJoin([
      this.siteConfigRuleService.findAll({partnerId: null}),
      this.siteConfigParamService.findAll()
    ]).subscribe(([siteConfigRules, siteConfigParams]) => {
      this.siteConfigRules = siteConfigRules;
      this.siteConfigParams = siteConfigParams;

      this.loader.stopLoading();
    });
  }

  canUpdate(): boolean {
    return this.auth.hasRolesSync(['ROLE_API_SITE_WRITE']);
  }
}
